import React from "react";
import { IDSFooterInera } from "@inera/ids-react";

const Footer = () => {
  return (
    <IDSFooterInera
      headline="Inera"
      subFooterRight={<p>Inera AB ägs av SKR, regioner och kommuner.</p>}
    >
      <p>
        Inera är kommunernas och regionernas digitaliseringsbolag med uppdrag att utveckla välfärden
      </p>
    </IDSFooterInera>
  );
};

export default Footer;